// Auto-generated from Google Doc TOS. Do not hand-edit.
const TOS = {
  "header": "Terms of Service (TOS)",
  "updated": "Last Updated: July 23, 2026",
  "preamble": [
    "These Terms become binding on you when you first accept them, create an account, purchase a subscription, or access or use the Software, whichever occurs first."
  ],
  "sections": [
    {
      "num": "1",
      "title": "ACCEPTANCE OF TERMS",
      "blocks": [
        {
          "t": "p",
          "text": "These Terms of Service (“Terms”) constitute a legally binding agreement between you and Arvance, LLC (“Company,” “we,” “us,” or “our”) and govern your access to and use of the Company’s software-as-a-service platform, related applications, data, reports, analytics, and associated services (collectively, the “Software”)."
        },
        {
          "t": "p",
          "text": "By accessing, registering for, subscribing to, or otherwise using the Software, you:"
        },
        {
          "t": "ul",
          "items": [
            "acknowledge that you have read and understood these Terms;",
            "agree to be legally bound by these Terms; and",
            "represent that you have the legal authority to enter into these Terms on behalf of yourself or the entity you represent."
          ]
        },
        {
          "t": "p",
          "text": "If you do not agree to these Terms, you may not access or use the Software."
        },
        {
          "t": "p",
          "text": "Your electronic acceptance of these Terms—including by clicking “I Agree,” creating an account, purchasing a subscription, or accessing or using the Software—constitutes your binding acceptance of these Terms."
        },
        {
          "t": "p",
          "text": "Privacy: The Company's collection, use, disclosure, retention, and protection of personal information are described in the Company's Privacy Policy, as published on the Company's website. The Privacy Policy is incorporated into these Terms by reference to the extent permitted by applicable law."
        },
        {
          "t": "p",
          "text": "No Reliance on Unstated Commitments: These Terms, together with any applicable order form and the Pricing Page as expressly incorporated herein, govern your use of the Software and supersede prior or contemporaneous statements, representations, marketing materials, website content, and communications concerning the Software, whether oral or written."
        },
        {
          "t": "p",
          "text": "Demonstrations, examples, projections, product roadmaps, promotional materials, and other statements not expressly incorporated into these Terms, an applicable order form, or the Pricing Page at the time of purchase do not create any guarantee regarding results, features, financial outcomes, or future functionality."
        },
        {
          "t": "p",
          "text": "Nothing in this subsection excludes any liability, right, or remedy that cannot lawfully be excluded."
        }
      ]
    },
    {
      "num": "2",
      "title": "DEFINITIONS",
      "blocks": [
        {
          "t": "ul",
          "items": [
            "“Authorized User” means an individual authorized by an account owner or administrator to access a team account under an applicable subscription plan.",
            "“Company IP” means the Software and the Company’s proprietary technology, source code, designs, documentation, templates, scoring systems, methodologies, and other intellectual property, excluding User Data and Third-Party Components or materials.",
            "“Output” means any report, calculation, analysis, estimate, visualization, export, or other result generated through the Software for an account.",
            "“Pricing Page” means the Company webpage or in-product purchase screen displaying the applicable subscription prices, billing periods, plan limits, features, and entitlements at the time of purchase.",
            "“Subscription Term” means the applicable billing period for which subscription fees have been paid.",
            "“User Data” means data, content, files, assumptions, property information, and other materials submitted to the Software by or on behalf of you or an Authorized User, excluding Feedback and Company IP."
          ]
        }
      ]
    },
    {
      "num": "3",
      "title": "ELIGIBILITY AND BUSINESS USE",
      "blocks": [
        {
          "t": "p",
          "text": "Eligibility: By accessing or using the Software, you represent and warrant that:"
        },
        {
          "t": "ul",
          "items": [
            "You are at least eighteen (18) years old;",
            "You possess the legal capacity and authority to enter into binding agreements;",
            "If you access or use the Software on behalf of an entity, you have authority to bind that entity;",
            "You will use the Software only for lawful business purposes consistent with these Terms;",
            "You will not use the Software to provide regulated investment advisory services unless properly licensed;",
            "You will not use the Software to solicit investments in violation of applicable securities laws; and",
            "Your use of the Software will comply with all applicable federal, state, local, and other applicable laws and regulations."
          ]
        },
        {
          "t": "p",
          "text": "Company Rights: The Company may refuse service or suspend or terminate access if you fail to satisfy these eligibility requirements."
        },
        {
          "t": "p",
          "text": "Accuracy of User Data: You represent and warrant that all User Data, information, assumptions, and other inputs you submit to the Software are accurate and provided in good faith to the best of your knowledge."
        },
        {
          "t": "p",
          "text": "The Company is not responsible for inaccuracies, errors, or misleading Outputs resulting from incorrect, incomplete, outdated, or misleading User Data or other information submitted by you or an Authorized User."
        }
      ]
    },
    {
      "num": "4",
      "title": "ACCOUNTS, AUTHORIZED USERS, AND SECURITY",
      "blocks": [
        {
          "t": "p",
          "text": "Account Creation: To access certain features of the Software, you must create an account and provide accurate, complete, and current information."
        },
        {
          "t": "p",
          "text": "Authorized Users and Team Accounts: The account owner or administrator may invite, remove, and manage Authorized Users and may access, export, modify, or delete User Data within the applicable team workspace."
        },
        {
          "t": "p",
          "text": "You are responsible for ensuring that all Authorized Users comply with these Terms."
        },
        {
          "t": "p",
          "text": "Removal from a team account may result in the loss of access to User Data owned or controlled by that team account."
        },
        {
          "t": "p",
          "text": "Your Responsibilities: You are responsible for:"
        },
        {
          "t": "ul",
          "items": [
            "activity conducted through your account to the extent resulting from your acts, omissions, credential sharing, or failure to use reasonable security measures;",
            "promptly updating inaccurate or outdated account information;",
            "maintaining the confidentiality of your account credentials; and",
            "promptly notifying the Company of any unauthorized access to, or suspected compromise of, your account."
          ]
        },
        {
          "t": "p",
          "text": "Your Security Responsibilities: You are responsible for:"
        },
        {
          "t": "ul",
          "items": [
            "maintaining appropriate security measures for your devices, networks, password management, and backups; and",
            "independently securing any exported or backed-up User Data."
          ]
        },
        {
          "t": "p",
          "text": "Prohibited Account Practices: You may not:"
        },
        {
          "t": "ul",
          "items": [
            "share account credentials;",
            "permit multiple users to access a single-user subscription; or",
            "circumvent subscription plan restrictions or usage limits."
          ]
        },
        {
          "t": "p",
          "text": "Account Suspension: The Company may suspend or terminate accounts reasonably suspected of credential sharing, misuse, fraud, or activity inconsistent with the applicable subscription plan."
        },
        {
          "t": "p",
          "text": "Unauthorized Access: You acknowledge that unauthorized access may occur despite commercially reasonable safeguards. Except as required by applicable law, the Company is not liable for losses resulting from unauthorized access."
        },
        {
          "t": "p",
          "text": "Enforcement Discretion: The Company reserves the right, but not the obligation, to issue warnings, suspend access, or terminate accounts based on the severity, frequency, or nature of violations."
        },
        {
          "t": "p",
          "text": "Where reasonably necessary to protect the Software, other users, or the Company's legal or business interests, the Company may take immediate action without prior notice."
        },
        {
          "t": "p",
          "text": "Data Export and Backups: You are strongly encouraged to regularly export and back up your User Data. The Software is not intended to serve as your sole system of record."
        },
        {
          "t": "p",
          "text": "No Guarantee of Data Recovery: The Company does not guarantee that deleted, corrupted, or lost User Data can be recovered. Any exclusions or limitations relating to data loss remain subject to the liability carve-outs and non-waivable rights set forth elsewhere in these Terms."
        }
      ]
    },
    {
      "num": "5",
      "title": "SUBSCRIPTIONS, BILLING, RENEWAL, CANCELLATION, AND TAXES",
      "blocks": [
        {
          "t": "p",
          "text": "Subscription Fees: Access to the Software requires payment of the fees applicable to your selected subscription plan, as described on the Pricing Page, which is incorporated into these Terms by reference."
        },
        {
          "t": "p",
          "text": "Billing and Payment: By purchasing a subscription, you agree:"
        },
        {
          "t": "ul",
          "items": [
            "to pay all applicable fees;",
            "that subscription fees are billed in advance;",
            "that all payments are non-refundable except as required by applicable law;",
            "that unused portions of a subscription are not eligible for refunds, credits, or prorated adjustments;",
            "that modifications to features or functionality do not entitle you to a refund or credit except as expressly provided in these Terms or required by applicable law; and",
            "that failure to pay applicable fees may result in immediate suspension or termination of access."
          ]
        },
        {
          "t": "p",
          "text": "Taxes: Subscription fees exclude applicable sales, use, value-added, withholding, and similar taxes unless expressly stated otherwise. You are responsible for all applicable taxes other than taxes imposed on the Company's net income."
        },
        {
          "t": "p",
          "text": "Payment Processors: Payments may be processed by third-party payment processors. Where payment information is handled by the processor, the Company does not store complete payment-card information. Your use of payment services may also be subject to the processor's applicable terms and privacy policy."
        },
        {
          "t": "p",
          "text": "Failed Payments: If a payment fails, the Company may retry the payment method, request updated payment information, restrict paid features, or suspend access after reasonable notice where practicable."
        },
        {
          "t": "p",
          "text": "Free Trials: Unless expressly stated otherwise before registration, access to the Software will end or become restricted upon expiration of the free trial, and you will not be charged unless you affirmatively purchase a paid subscription."
        },
        {
          "t": "p",
          "text": "Billing Authorization: You authorize the Company and its payment processors to charge all applicable subscription fees, taxes, and renewal charges without further notice, except where notice is required by applicable law."
        },
        {
          "t": "p",
          "text": "Automatic Renewal: Subscriptions automatically renew at the end of each billing cycle unless canceled before renewal."
        },
        {
          "t": "p",
          "text": "Where required by applicable law, the Company will provide advance notice of renewal at least ten (10) days before the applicable billing date."
        },
        {
          "t": "p",
          "text": "Cancellation: You may cancel your subscription through the billing settings within the Software or by contacting support@reilm.io."
        },
        {
          "t": "p",
          "text": "Cancellation becomes effective at the end of the current prepaid billing period unless applicable law requires otherwise. Cancellation does not automatically delete your account or User Data."
        },
        {
          "t": "p",
          "text": "Refund Policy: Except as required by applicable law, subscription fees are non-refundable. You remain responsible for all accrued subscription fees through the effective date of cancellation."
        },
        {
          "t": "p",
          "text": "Discretionary Refunds and Credits: Notwithstanding the foregoing, the Company may, in its sole discretion, issue refunds, credits, or billing adjustments in exceptional circumstances."
        },
        {
          "t": "p",
          "text": "Suspension for Nonpayment or Violations: Suspension of access due to nonpayment, violation of these Terms, or other permitted reasons does not relieve you of your payment obligations. Billing will continue unless your subscription is canceled."
        },
        {
          "t": "p",
          "text": "Pricing and Renewal Disclosures: You acknowledge that subscription pricing, billing frequency, renewal terms, and applicable plan details are disclosed on the Pricing Page before purchase and that you are responsible for reviewing those terms before subscribing."
        },
        {
          "t": "p",
          "text": "No Reliance on Unstated Pricing Terms: You acknowledge that you have not relied on pricing representations, discounts, or promotional statements unless expressly stated on the applicable Pricing Page at the time of purchase."
        }
      ]
    },
    {
      "num": "6",
      "title": "PLAN LIMITS AND PRODUCT CHANGES",
      "blocks": [
        {
          "t": "p",
          "text": "Subscription Plans: Each subscription plan includes specific usage limits, features, and entitlements as described on the Pricing Page, which is incorporated into these Terms by reference."
        },
        {
          "t": "p",
          "text": "Plan limits and features may include, without limitation, restrictions or allocations relating to properties, user seats, team functionality, storage, and access to particular tools or features, depending on your selected subscription plan."
        },
        {
          "t": "p",
          "text": "You are responsible for reviewing the Pricing Page to understand the limits, features, and entitlements applicable to your subscription, as those details may change from time to time."
        },
        {
          "t": "p",
          "text": "Unlimited Features: Unless expressly stated otherwise, \"Unlimited\" means that a feature is not subject to a fixed ordinary-use limit. Unlimited access remains subject to these Terms, technical safeguards, and reasonable measures addressing abuse, unlawful activity, or use materially inconsistent with the intended operation of the Software."
        },
        {
          "t": "p",
          "text": "Company Rights: The Company may:"
        },
        {
          "t": "ul",
          "items": [
            "modify subscription plan limits;",
            "add, remove, replace, or reclassify features; and",
            "modify subscription pricing or reprice subscription tiers."
          ]
        },
        {
          "t": "p",
          "text": "Usage Measurement: The Pricing Page or applicable in-product documentation will describe how usage is measured, including what constitutes a property, user seat, comp search, report, template, or other metered unit."
        },
        {
          "t": "p",
          "text": "The Company may update usage measurement rules prospectively to address abuse, technical changes, or new functionality, but will not retroactively reclassify prior compliant usage solely to impose additional charges."
        },
        {
          "t": "p",
          "text": "No Feature Guarantee: Except as expressly provided in these Terms or required by applicable law, the Company does not guarantee the continued availability of any particular feature, functionality, or third-party integration."
        },
        {
          "t": "p",
          "text": "Material Plan Changes: The Company may modify the Software and its subscription plans from time to time."
        },
        {
          "t": "p",
          "text": "If the Company materially reduces a core paid feature during your current prepaid Subscription Term, it will provide reasonable advance notice where practicable. Where required by applicable law, the Company will provide an appropriate remedy, which may include continued access through the current billing period, the opportunity to cancel before renewal, a plan adjustment, or a prorated credit or refund."
        },
        {
          "t": "p",
          "text": "Downgrades: Downgrading your subscription may reduce applicable limits, features, user seats, storage, or access to certain tools beginning with the next billing period."
        },
        {
          "t": "p",
          "text": "If your existing usage exceeds your downgraded plan's limits, the Company may restrict the creation of new items or use of affected features until your usage is reduced or your subscription is upgraded."
        },
        {
          "t": "p",
          "text": "The Company will not intentionally delete existing User Data solely because of a downgrade without reasonable notice, except where retention is technically infeasible or required for security or legal reasons."
        },
        {
          "t": "p",
          "text": "Product Evolution: You acknowledge that the Software is an evolving product. Features, tools, workflows, user interface elements, and data sources may be modified, replaced, or removed over time without creating liability, except as otherwise expressly provided in these Terms or required by applicable law."
        }
      ]
    },
    {
      "num": "7",
      "title": "SOFTWARE AVAILABILITY AND MODIFICATIONS",
      "blocks": [
        {
          "t": "p",
          "text": "The Software is provided on an \"as is\" and \"as available\" basis."
        },
        {
          "t": "p",
          "text": "No Availability Guarantee: The Company does not guarantee uninterrupted, secure, or error-free access to the Software. Downtime, interruptions, maintenance, or feature changes do not entitle you to refunds or damages except where required by applicable law."
        },
        {
          "t": "p",
          "text": "Company Operational Rights: The Company may:"
        },
        {
          "t": "ul",
          "items": [
            "modify, update, enhance, reduce, or discontinue any aspect of the Software;",
            "suspend access for maintenance, upgrades, legal compliance, security, or operational reasons; and",
            "impose reasonable usage limits, throttling, or other technical safeguards."
          ]
        },
        {
          "t": "p",
          "text": "No Reliance on Availability: You acknowledge that temporary or extended downtime, interruptions, or service degradation may occur. You agree not to rely on the Software for time-sensitive, mission-critical, or irreversible decisions without independent verification."
        }
      ]
    },
    {
      "num": "8",
      "title": "LICENSE GRANT AND ACCEPTABLE USE",
      "blocks": [
        {
          "t": "p",
          "text": "License Grant: Subject to these Terms, the Company grants you a limited, revocable, non-exclusive, non-transferable, and non-sublicensable license to access and use the Software for your internal business operations and for other business activities expressly permitted by these Terms, including sharing permitted Outputs with clients, partners, lenders, buyers, investors, and other professional contacts in the ordinary course of your real estate business."
        },
        {
          "t": "p",
          "text": "License Restrictions: You may not:"
        },
        {
          "t": "ul",
          "items": [
            "reproduce, modify, or create derivative works of the Software except as expressly authorized by these Terms;",
            "redistribute, resell, sublicense, lease, or provide the Software on a service bureau or hosted-services basis; or",
            "remove, obscure, or alter proprietary notices contained in the Software."
          ]
        },
        {
          "t": "p",
          "text": "License Suspension and Termination: The Company may immediately suspend or terminate the license granted under these Terms if you violate these Terms or otherwise engage in unauthorized use of the Software."
        }
      ]
    },
    {
      "num": "9",
      "title": "OUTPUTS AND PERMITTED USE",
      "blocks": [
        {
          "t": "p",
          "text": "Permitted Use: Subject to these Terms, you may access, download, reproduce, and share reports and Outputs generated for your account in connection with your lawful real estate business, including with buyers, sellers, clients, brokers, contractors, lenders, partners, investors, and professional advisors."
        },
        {
          "t": "p",
          "text": "This permission does not authorize you to:"
        },
        {
          "t": "ul",
          "items": [
            "extract or disclose non-public Company algorithms, scoring weights, source code, proprietary methodologies, or technical documentation;",
            "reproduce or use the Software to create a competing product; or",
            "represent any Output as an appraisal, broker price opinion, certified valuation, or professional advice."
          ]
        },
        {
          "t": "p",
          "text": "Ownership: As between you and the Company, you retain ownership of your User Data and, subject to these Terms, may use and share permitted Outputs generated for your account."
        },
        {
          "t": "p",
          "text": "The Company retains ownership of all Company IP incorporated into, embodied in, or used to generate those Outputs. No ownership interest in the Company's Software, algorithms, methodologies, reusable templates, or other Company IP transfers to you."
        },
        {
          "t": "p",
          "text": "Restrictions: You may not:"
        },
        {
          "t": "ul",
          "items": [
            "extract, reproduce, publicly distribute, or commercialize a standalone Company template or report format separate from a permitted Output generated for your account;",
            "replicate or publish the Company's ARV methodologies;",
            "disclose or attempt to derive non-public algorithms, scoring weights, model parameters, source code, or proprietary calculation logic, except that you may disclose values, assumptions, adjustments, formulas, and explanations intentionally displayed in a permitted Output;",
            "use exported Outputs to develop or support competing products or services; or",
            "misrepresent any Output as a certified valuation, professional appraisal, broker price opinion, or other professional advice."
          ]
        },
        {
          "t": "p",
          "text": "No Certification: Reports, Outputs, and analyses generated by the Software are provided solely for informational purposes. They are not appraisals, broker price opinions, certified valuations, or professional advice and must not be represented as such."
        }
      ]
    },
    {
      "num": "10",
      "title": "USER DATA AND FEEDBACK",
      "blocks": [
        {
          "t": "p",
          "text": "Ownership of User Data: You retain ownership of the User Data you submit to the Software."
        },
        {
          "t": "p",
          "text": "License to Process User Data: You grant the Company a non-exclusive, worldwide, royalty-free license, during the term of your account, to host, copy, transmit, display, process, and modify User Data solely as technically necessary to provide, secure, maintain, support, and improve the Software; prevent fraud and abuse; comply with applicable law; and enforce these Terms."
        },
        {
          "t": "p",
          "text": "Aggregated / De-identified Data: Subject to the Privacy Policy, the Company may create and use aggregated or de-identified information that does not reasonably identify you, an Authorized User, or a specific property or transaction for analytics, benchmarking, security, product improvement, and the development of products, models, or features."
        },
        {
          "t": "p",
          "text": "Privacy: Except as described in the Privacy Policy or authorized by you, the Company will not sell User Data or use confidential property-level or transaction-level User Data to publicly identify you."
        },
        {
          "t": "p",
          "text": "Representations: You represent and warrant that you possess all rights, permissions, and authority necessary to submit User Data and to authorize the Company to process that User Data as described in these Terms and the Privacy Policy."
        },
        {
          "t": "p",
          "text": "Feedback License: By submitting feedback, suggestions, comments, or ideas relating to the Software (\"Feedback\"), you grant the Company a perpetual, irrevocable, worldwide, royalty-free, sublicensable, and transferable license to use, copy, modify, distribute, commercialize, and incorporate such Feedback into the Software or other products without compensation, attribution, or creating any ownership interest in the Software."
        },
        {
          "t": "p",
          "text": "Submission of Feedback does not grant you any ownership interest in the Software or other Company IP."
        }
      ]
    },
    {
      "num": "11",
      "title": "INTELLECTUAL PROPERTY COMPLAINTS",
      "blocks": [
        {
          "t": "p",
          "text": "Infringing Content: The Company may remove or restrict access to User Data that it reasonably believes infringes the intellectual property or other rights of a third party and may suspend or terminate repeat infringers."
        },
        {
          "t": "p",
          "text": "Notice of Claimed Infringement: A notice of alleged infringement should be sent to legal@reilm.io and include:"
        },
        {
          "t": "ul",
          "items": [
            "identification of the protected work;",
            "identification and location of the allegedly infringing material;",
            "the claimant's contact information;",
            "the basis for the claim; and",
            "a statement that the claimant has a good-faith belief that the disputed use is unauthorized."
          ]
        },
        {
          "t": "p",
          "text": "Additional Information: The Company may request additional information or documentation before taking action on an infringement claim."
        }
      ]
    },
    {
      "num": "12",
      "title": "PROHIBITED USES",
      "blocks": [
        {
          "t": "p",
          "text": "You agree not to:"
        },
        {
          "t": "p",
          "text": "Unlawful or Unauthorized Use"
        },
        {
          "t": "ul",
          "items": [
            "use the Software in violation of any applicable law or regulation;",
            "access or attempt to access another user's account or User Data without authorization;",
            "use the Software to provide regulated financial or investment advisory services without all required licenses, registrations, or legal authority;",
            "use the Software or Third-Party Data as a \"consumer report,\" or to determine eligibility for credit, insurance, employment, housing, tenancy, or any other purpose regulated by the Fair Credit Reporting Act, unless expressly authorized in writing by the Company and all applicable legal requirements are satisfied; or",
            "use the Software, User Data, Third-Party Data, tags, scoring, analytics, marketing tools, or Outputs to unlawfully discriminate or facilitate unlawful discrimination in housing, lending, advertising, property access, or real estate transactions based on any characteristic protected by applicable law."
          ]
        },
        {
          "t": "p",
          "text": "Reverse Engineering and Intellectual Property Misuse"
        },
        {
          "t": "ul",
          "items": [
            "reverse engineer, decompile, disassemble, copy, scrape, extract, or otherwise attempt to discover the source code, algorithms, models, logic, architecture, or underlying structure of the Software;",
            "resell, sublicense, lease, white-label, or otherwise commercially exploit the Software except as expressly authorized by the Company; or",
            "access or use the Software on behalf of a competitor for unauthorized benchmarking, competitive analysis, reverse engineering, or the development of a competing product or service."
          ]
        },
        {
          "t": "p",
          "text": "Automated Access and Data Extraction"
        },
        {
          "t": "ul",
          "items": [
            "use bots, crawlers, scripts, automated scraping tools, or other automated means to access, monitor, or collect information from the Software without the Company's prior written authorization;",
            "systematically access, scrape, extract, download, reproduce, compile, aggregate, or harvest Software content, User Data, Third-Party Data, reports, Outputs, analytics, or other information to create or support a database, dataset, valuation tool, competing service, investment platform, or any machine learning or artificial intelligence model, except through functionality expressly provided by the Company or otherwise authorized in writing; or",
            "circumvent, disable, interfere with, or attempt to bypass technical safeguards, security measures, rate limits, usage restrictions, monitoring systems, or access controls implemented by the Company."
          ]
        },
        {
          "t": "p",
          "text": "Artificial Intelligence and Competitive Use"
        },
        {
          "t": "ul",
          "items": [
            "use the Software or any Output to develop, benchmark, validate, fine-tune, train, or improve any machine learning, artificial intelligence, or similar automated system; or",
            "use the Software to develop, compete with, benchmark against, or replicate any product, service, feature, methodology, or functionality of the Software."
          ]
        },
        {
          "t": "p",
          "text": "Output Misuse"
        },
        {
          "t": "ul",
          "items": [
            "misrepresent any Output as a certified valuation, professional appraisal, broker price opinion, legal advice, financial advice, investment advice, or other professional opinion or certification."
          ]
        }
      ]
    },
    {
      "num": "13",
      "title": "INTELLECTUAL PROPERTY",
      "blocks": [
        {
          "t": "p",
          "text": "Ownership of Company IP: All Software, algorithms, scoring methodologies, ARV calculations, designs, templates, reports, content, and source code (collectively, \"Company IP\") are and remain the exclusive property of the Company."
        },
        {
          "t": "p",
          "text": "Trade Secrets: The Software, including its algorithms, scoring methodologies, data models, weighting systems, ARV calculations, and other non-public methodologies, constitutes proprietary trade secrets of the Company."
        },
        {
          "t": "p",
          "text": "License Grant: The License Grant set forth above governs all use of the Software. No additional rights are granted under this Intellectual Property section."
        },
        {
          "t": "p",
          "text": "Except for the limited license expressly granted in these Terms, no rights or licenses are granted by implication, estoppel, or otherwise."
        },
        {
          "t": "p",
          "text": "All templates, formats, calculations, methodologies, and system-generated logic remain Company IP, even when incorporated into Outputs."
        },
        {
          "t": "p",
          "text": "Related Restrictions: The restrictions set forth in the License Grant and Acceptable Use and Prohibited Uses sections apply to all Company IP and are incorporated into this section by reference."
        }
      ]
    },
    {
      "num": "14",
      "title": "CONFIDENTIALITY",
      "blocks": [
        {
          "t": "p",
          "text": "Definition: The Software, including its algorithms, scoring methodologies, ARV calculations, valuation logic, system architecture, datasets, models, workflows, user interfaces, technical documentation, and other non-public information relating to the Software, contains proprietary and confidential information of the Company (\"Confidential Information\")."
        },
        {
          "t": "p",
          "text": "Exclusions: Confidential Information does not include information that you can demonstrate:"
        },
        {
          "t": "ul",
          "items": [
            "is or becomes publicly available without breach of these Terms;",
            "was lawfully known to you without confidentiality restrictions before disclosure;",
            "is lawfully obtained from a third party without a duty of confidentiality; or",
            "is independently developed without use of the Company's Confidential Information."
          ]
        },
        {
          "t": "p",
          "text": "Required Disclosures: You may disclose Confidential Information when required by law, subpoena, or court order, provided that, where legally permitted, you give the Company reasonable advance notice and cooperate in seeking appropriate protective treatment."
        },
        {
          "t": "p",
          "text": "Obligations: You agree not to:"
        },
        {
          "t": "ul",
          "items": [
            "disclose Confidential Information to any third party;",
            "use Confidential Information for any purpose other than your permitted use of the Software; or",
            "reverse engineer, analyze, or otherwise attempt to derive Confidential Information from the Software or its Outputs."
          ]
        },
        {
          "t": "p",
          "text": "Survival: Your confidentiality obligations survive termination:"
        },
        {
          "t": "ul",
          "items": [
            "indefinitely with respect to trade secrets; and",
            "for five (5) years with respect to all other Confidential Information."
          ]
        }
      ]
    },
    {
      "num": "15",
      "title": "MONITORING AND AUDITS",
      "blocks": [
        {
          "t": "p",
          "text": "Company Rights: The Company reserves the right to:"
        },
        {
          "t": "ul",
          "items": [
            "monitor usage patterns;",
            "audit compliance with subscription plan limits;",
            "investigate suspected violations;",
            "suspend or terminate accounts as permitted by these Terms; and",
            "pursue available legal or equitable remedies."
          ]
        },
        {
          "t": "p",
          "text": "User Cooperation: Upon reasonable written request concerning a suspected material violation of these Terms, you will provide information reasonably necessary to verify compliance."
        },
        {
          "t": "p",
          "text": "The Company will conduct any audit in a manner designed to avoid unreasonable disruption and will not require access to your devices, systems, or unrelated confidential information unless separately agreed in writing or required by applicable law."
        },
        {
          "t": "p",
          "text": "Usage Monitoring Consent: You acknowledge and consent to the Company monitoring, logging, and analyzing usage activity within the Software for purposes including:"
        },
        {
          "t": "ul",
          "items": [
            "security;",
            "abuse prevention;",
            "fraud detection;",
            "technical troubleshooting;",
            "service improvement; and",
            "enforcement of these Terms."
          ]
        }
      ]
    },
    {
      "num": "16",
      "title": "THIRD-PARTY SERVICES AND DATA",
      "blocks": [
        {
          "t": "p",
          "text": "Third-Party Components: The Software may incorporate or rely upon third-party libraries, open-source software, APIs, data feeds, integrations, or other pre-existing materials (“Third-Party Components”). Such Third-Party Components are licensed to the Company under applicable agreements or otherwise used in accordance with applicable law. Nothing in these Terms grants you ownership of any Third-Party Components, and your use of Third-Party Components may be subject to applicable third-party terms."
        },
        {
          "t": "p",
          "text": "Third-Party Integrations: The Software may integrate with third-party tools, platforms, services, or data providers. The Company does not control and does not warrant or guarantee the availability, accuracy, legality, performance, security, or continued operation of any third-party integrations. Your use of such integrations is at your own risk and may be subject to the third party’s terms and privacy policies. The Company may modify, suspend, or discontinue any third-party integration at any time without liability."
        },
        {
          "t": "p",
          "text": "Third-Party Data: The Software may display, process, or analyze data obtained from third-party sources, including but not limited to property records, public records, square footage, ownership data, pricing history, market metrics, and other real estate-related information (“Third-Party Data”)."
        },
        {
          "t": "p",
          "text": "Third-Party Data Disclaimer: You acknowledge that:"
        },
        {
          "t": "ul",
          "items": [
            "The Company does not guarantee the completeness, accuracy, timeliness, legality, or reliability of Third-Party Data;",
            "Third-Party Data may contain errors, omissions, inaccuracies, or outdated information;",
            "Third-party providers may modify, restrict, or discontinue access at any time; and",
            "Calculations, analyses, reports, or other Outputs generated using Third-Party Data may be affected."
          ]
        },
        {
          "t": "p",
          "text": "Independent Verification: You expressly agree that all property data, ARV estimates, rent comps, deal scoring, projections, and analytics must be independently verified before relying on them in any transaction or investment decision."
        }
      ]
    },
    {
      "num": "17",
      "title": "DATA PROTECTION & SECURITY",
      "blocks": [
        {
          "t": "p",
          "text": "Account Security Responsibilities: You are solely responsible for:"
        },
        {
          "t": "ul",
          "items": [
            "Maintaining the confidentiality of your account credentials;",
            "Restricting access to your account and devices;",
            "Ensuring that all activity under your account complies with these Terms."
          ]
        },
        {
          "t": "p",
          "text": "Security Safeguards: The Company implements commercially reasonable safeguards to protect User Data. However, no security measure is completely secure, and the Company cannot guarantee absolute security. Subject to these Terms, the Company is not responsible for unauthorized access, data loss, or corruption caused by factors beyond its reasonable control."
        },
        {
          "t": "p",
          "text": "Nothing in these Terms limits the Company’s liability for gross negligence, willful misconduct, or violation of applicable laws."
        },
        {
          "t": "p",
          "text": "You remain responsible for maintaining appropriate security for your own devices, networks, and backups."
        },
        {
          "t": "p",
          "text": "Data Recovery: The Company does not guarantee that lost, deleted, corrupted, or otherwise unavailable User Data can be recovered."
        },
        {
          "t": "p",
          "text": "No Absolute Security Guarantee: You acknowledge that the Company does not guarantee prevention of all unauthorized access, and you agree that the Company shall not be deemed negligent solely due to the occurrence of a security incident."
        },
        {
          "t": "p",
          "text": "Security Incidents: In the event of a security incident affecting the Software, the Company will take commercially reasonable steps to investigate and mitigate the incident."
        },
        {
          "t": "p",
          "text": "Limitation of Liability for Security Incidents: Subject to the Non-Waivable Liability provision and to the maximum extent permitted by law, the Company shall not be liable for:"
        },
        {
          "t": "ul",
          "items": [
            "Unauthorized access to or alteration of User Data;",
            "Data loss, corruption, or destruction;",
            "Service interruptions caused by cyberattacks, malware, ransomware, distributed denial-of-service attacks, or other malicious activity;",
            "Indirect, incidental, consequential, or punitive damages arising from any security incident."
          ]
        },
        {
          "t": "p",
          "text": "Except for rights and remedies that cannot lawfully be waived, you may discontinue use of the Software if you are dissatisfied with its security measures."
        }
      ]
    },
    {
      "num": "18",
      "title": "DISCLAIMER OF WARRANTIES",
      "blocks": [
        {
          "t": "p",
          "text": "Software Provided “As Is”: THE SOFTWARE AND ALL CONTENT, REPORTS, CALCULATIONS, OUTPUTS, DATA, AND SERVICES ARE PROVIDED “AS IS” AND “AS AVAILABLE,” WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE."
        },
        {
          "t": "p",
          "text": "Express Disclaimer: TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE COMPANY EXPRESSLY DISCLAIMS ALL WARRANTIES, INCLUDING BUT NOT LIMITED TO:"
        },
        {
          "t": "ul",
          "items": [
            "IMPLIED WARRANTIES OF MERCHANTABILITY;",
            "FITNESS FOR A PARTICULAR PURPOSE;",
            "TITLE;",
            "NON-INFRINGEMENT;",
            "ACCURACY OR COMPLETENESS OF DATA;",
            "RELIABILITY OF OUTPUTS OR CALCULATIONS;",
            "UNINTERRUPTED OR ERROR-FREE OPERATION;",
            "RESULTS OR PROFITABILITY FROM USE OF THE SOFTWARE."
          ]
        },
        {
          "t": "p",
          "text": "Specific Non-Warranties: The Company does not warrant that:"
        },
        {
          "t": "ul",
          "items": [
            "the Software will meet your requirements;",
            "results will be accurate or suitable for investment decisions;",
            "defects will be corrected; or",
            "the Software is free from viruses or other harmful components."
          ]
        },
        {
          "t": "p",
          "text": "Your Responsibility and Independent Judgment"
        },
        {
          "t": "ul",
          "items": [
            "Your Responsibility: You acknowledge that you are solely responsible for verifying all data, analyses, ARV calculations, property metrics, and Outputs before relying on them for business, investment, or financial decisions.",
            "Informational Use: You expressly acknowledge and agree that the Software is provided solely as an informational and analytical tool.",
            "Independent Verification: You agree not to rely on the Software, the Company, or any Outputs as the sole or primary basis for investment, financial, lending, purchasing, or business decisions. You also agree to conduct independent due diligence and consult qualified professionals, including brokers, appraisers, attorneys, accountants, lenders, or financial advisors.",
            "No Responsibility for Your Decisions: The Company shall not be responsible for decisions made or actions taken based on Outputs, analyses, or reports.",
            "Professional Sophistication: You acknowledge that real estate decisions involve risks and require independent judgment. You are responsible for obtaining appropriate professional assistance based on your experience and the nature of the transaction."
          ]
        },
        {
          "t": "p",
          "text": "Specific Product Disclaimers"
        },
        {
          "t": "ul",
          "items": [
            "ARV and Analytics: Without limiting the foregoing, ARV calculations, rent comparables, deal scoring systems, projections, and investment analyses are inherently uncertain, may rely on incomplete or outdated data, and are provided solely for informational purposes.",
            "Financial Analysis and Data: The Software provides financial analysis tools, projections, and reports based on user-provided inputs and automatically sourced data, including third-party or public data (e.g., property metrics, square footage, public records), which may be incomplete, inaccurate, or outdated. You rely on all analyses, projections, and Outputs at your own risk.",
            "Market Volatility: Real estate markets, property values, rents, construction costs, financing conditions, and economic factors may change rapidly and unpredictably. The Company does not represent or warrant that Outputs, valuations, projections, or analytics reflect current or future market conditions.",
            "Marketing Materials: Examples, testimonials, case studies, sample deals, projections, or illustrative scenarios are for informational purposes only and do not represent typical, expected, or guaranteed results.",
            "Automated Updates: The Software may automatically update calculations, reports, and projections based on new data, assumptions, or system improvements. Outputs may change over time, and the Company is not liable for variations."
          ]
        },
        {
          "t": "p",
          "text": "Professional Advice and Investment Risk"
        },
        {
          "t": "ul",
          "items": [
            "Professional Advice: The Software is for informational purposes only and does not constitute financial, investment, or legal advice. The Company is not a fiduciary, registered investment advisor, or legal professional. You are solely responsible for decisions based on Outputs.",
            "Investment Risk: You acknowledge that real estate investing involves substantial financial risk. Property valuations, projections, and analyses may not reflect actual market conditions. The Company is not liable for investment losses, failed transactions, missed opportunities, financing decisions, renovation cost overruns, or market fluctuations arising from reliance on Outputs."
          ]
        },
        {
          "t": "p",
          "text": "Essential Purpose: The limitations of liability set forth herein shall apply to the fullest extent permitted by law, even if any limited remedy fails of its essential purpose."
        }
      ]
    },
    {
      "num": "19",
      "title": "LIMITATION OF LIABILITY",
      "blocks": [
        {
          "t": "p",
          "text": "Exclusion of Certain Damages: To the maximum extent permitted by law, in no event shall the Company or its affiliates, officers, members, managers, directors, employees, contractors, licensors, or agents (collectively, the \"Company Parties\") be liable for:"
        },
        {
          "t": "ul",
          "items": [
            "indirect, incidental, consequential, special, exemplary, or punitive damages;",
            "lost profits, lost revenue, or lost business opportunities;",
            "loss of goodwill or reputation;",
            "loss, corruption, or inaccuracy of data;",
            "cost of substitute services;",
            "business interruption;",
            "diminution in value; or",
            "investment losses or real estate transaction losses."
          ]
        },
        {
          "t": "p",
          "text": "This limitation applies even if the Company has been advised of the possibility of such damages and regardless of the theory of liability, whether in contract, tort, negligence, strict liability, or otherwise."
        },
        {
          "t": "p",
          "text": "Aggregate Liability Cap: The total aggregate liability of the Company Parties arising out of or relating to the Software or these Terms shall not exceed the total fees paid by you during the twelve (12) months immediately preceding the event giving rise to the claim, or one hundred dollars (US $100.00) if no fees were paid. This limitation applies collectively to all claims, regardless of the number of claims, incidents, or legal theories asserted."
        },
        {
          "t": "p",
          "text": "Maximum Extent Permitted by Law: Certain jurisdictions do not permit the exclusion or limitation of certain damages. In such jurisdictions, the Company's liability shall be limited to the maximum extent permitted by applicable law."
        },
        {
          "t": "p",
          "text": "Exclusive Remedy: Except for remedies expressly provided in these Terms and rights that cannot lawfully be waived, your exclusive remedy if you are dissatisfied with the Software is to discontinue use of the Software and cancel your subscription."
        },
        {
          "t": "p",
          "text": "Company Injunctive Rights: Nothing in these Terms limits the Company's right to seek temporary, preliminary, permanent, or other appropriate equitable or injunctive relief for:"
        },
        {
          "t": "ul",
          "items": [
            "intellectual property infringement;",
            "misappropriation of trade secrets;",
            "breach of confidentiality; or",
            "unauthorized access to or use of the Software."
          ]
        },
        {
          "t": "p",
          "text": "Allocation of Risk: You acknowledge that the pricing of the Software reflects the allocation of risk set forth in these Terms and that the disclaimers and limitations of liability are essential elements of the parties' agreement."
        },
        {
          "t": "p",
          "text": "No Personal Liability: No owner, member, officer, director, employee, contractor, or agent of the Company shall have any personal liability arising out of or relating to the Software or these Terms."
        },
        {
          "t": "p",
          "text": "Non-Waivable Liability: Nothing in these Terms excludes or limits liability to the extent such liability cannot be excluded or limited under applicable law, including liability arising from the Company’s fraud, willful misconduct, or gross negligence where such exclusions are prohibited."
        }
      ]
    },
    {
      "num": "20",
      "title": "ENFORCEMENT AND REMEDIES",
      "blocks": [
        {
          "t": "p",
          "text": "Irreparable Harm: You acknowledge that unauthorized use or disclosure of Company IP may cause irreparable harm for which monetary damages would be an inadequate remedy. Accordingly, subject to applicable law and procedural requirements, the Company may seek temporary, preliminary, permanent, or other appropriate equitable or injunctive relief."
        },
        {
          "t": "p",
          "text": "Acknowledgment of Harm: You further acknowledge that unauthorized copying, scraping, reverse engineering, decompiling, attempts to derive source code, reproduction of functionality, development of a competing product, systematic extraction of data, or use of the Software to develop or train a competing system would cause substantial harm to the Company that would be difficult or impossible to precisely quantify."
        },
        {
          "t": "p",
          "text": "Available Remedies: A breach involving unauthorized access, scraping, reverse engineering, misuse of Company IP, or misappropriation of Confidential Information may cause harm that is difficult to quantify. Subject to applicable law, the Company may pursue all remedies available at law or in equity, including temporary, preliminary, and permanent injunctive relief, actual damages, statutory damages where available, and reasonable attorneys' fees and enforcement costs where authorized by law or contract."
        }
      ]
    },
    {
      "num": "21",
      "title": "INDEMNIFICATION",
      "blocks": [
        {
          "t": "p",
          "text": "Scope of Indemnification: You agree to indemnify, defend (at the Company’s election and under the Company’s control), and hold harmless the Company, its affiliates, officers, members, managers, directors, employees, contractors, licensors, successors, and assigns (collectively, the “Company Parties”) from and against any and all claims, demands, actions, suits, investigations, liabilities, damages, judgments, settlements, penalties, fines, costs, and expenses (including attorneys’ fees and costs of enforcement) arising out of or relating to:"
        },
        {
          "t": "ul",
          "items": [
            "Your violation of these Terms or any applicable law or regulation;",
            "Your use, misuse, or access to the Software;",
            "Your User Data, content, submissions, feedback, or other materials;",
            "Any allegation that your data or conduct infringes, misappropriates, or violates any third-party intellectual property, privacy, publicity, or other rights;",
            "Your breach of any representation, warranty, covenant, or obligation under these Terms;",
            "Any dispute between you and any third party relating to your use of the Software."
          ]
        },
        {
          "t": "p",
          "text": "Survival: Your indemnification obligations survive the termination or expiration of these Terms."
        },
        {
          "t": "p",
          "text": "Company Defense Rights: The Company may assume exclusive control of the defense and settlement of any covered claim, and you agree to provide reasonable cooperation as reasonably requested. The Company will not settle any covered claim in a manner that requires you to admit wrongdoing or assume any non-monetary obligation without your prior written consent, which shall not be unreasonably withheld, conditioned, or delayed."
        }
      ]
    },
    {
      "num": "22",
      "title": "FORCE MAJEURE",
      "blocks": [
        {
          "t": "p",
          "text": "The Company shall not be liable for any delay, failure, or interruption in performance resulting from causes beyond its reasonable control, including, without limitation:"
        },
        {
          "t": "ul",
          "items": [
            "natural disasters;",
            "acts of government;",
            "war or terrorism;",
            "labor disputes;",
            "internet or telecommunications failures;",
            "cloud service provider outages;",
            "cyberattacks, ransomware, or distributed denial-of-service attacks; and",
            "power outages or infrastructure failures."
          ]
        },
        {
          "t": "p",
          "text": "The Company will resume performance as soon as reasonably practicable after the force majeure event has ended."
        }
      ]
    },
    {
      "num": "23",
      "title": "TERMINATION",
      "blocks": [
        {
          "t": "p",
          "text": "Termination by User: You may cancel your subscription at any time. Unless otherwise required by applicable law, fees are non-refundable. Your access will continue through the end of the current prepaid billing period."
        },
        {
          "t": "p",
          "text": "Termination by Company: The Company may suspend, restrict, or terminate your account for violation or suspected material violation of these Terms; non-payment; fraud; security or operational risk; legal or regulatory requirements; extended inactivity; or conduct reasonably likely to harm the Software, the Company, or other users."
        },
        {
          "t": "p",
          "text": "The Company may also discontinue the Software or your account for legitimate business reasons. If the Company terminates a paid subscription without cause before the end of a prepaid Subscription Term, the Company will provide a prorated refund or credit for the unused portion unless prohibited by law or the termination results from a broader discontinuation governed by another remedy provided in these Terms."
        },
        {
          "t": "p",
          "text": "Effects of Termination: Upon termination:"
        },
        {
          "t": "ul",
          "items": [
            "all rights and licenses granted to you immediately terminate;",
            "you must immediately discontinue all use of the Software; and",
            "the Company may retain limited data for legal, regulatory, enforcement, security, or other legitimate business purposes."
          ]
        },
        {
          "t": "p",
          "text": "Post-Termination Access and Deletion: Following expiration or termination, the Company may disable access to your account. Unless the account was terminated for fraud, security risks, unlawful conduct, or another urgent reason, the Company may provide a period of up to thirty (30) days during which the account administrator may request an export of available User Data. Thereafter, the Company may delete User Data in accordance with its retention policies. The Company is not obligated to retain User Data indefinitely or recover data that has been deleted in accordance with these Terms. Legal, billing, security, backup, and compliance records may be retained as permitted or required by law."
        },
        {
          "t": "p",
          "text": "Operational Risk Protection: The Company may take immediate action, including suspension or termination, where it reasonably believes such action is necessary to prevent harm, legal exposure, or misuse of the Software, without prior investigation or notice where permitted by applicable law."
        },
        {
          "t": "p",
          "text": "Survival: Provisions that by their nature should survive termination will survive, including, without limitation, those relating to Intellectual Property, Confidentiality, Indemnification, Disclaimer of Warranties, Limitation of Liability, Dispute Resolution, and Governing Law."
        }
      ]
    },
    {
      "num": "24",
      "title": "GOVERNING LAW",
      "blocks": [
        {
          "t": "p",
          "text": "These Terms and any dispute arising out of or relating to these Terms or the Software shall be governed by and construed in accordance with the laws of the State of Georgia, without regard to its conflict-of-law principles."
        }
      ]
    },
    {
      "num": "25",
      "title": "LIMITATION PERIOD FOR CLAIMS",
      "blocks": [
        {
          "t": "p",
          "text": "Time Limit: To the maximum extent permitted by applicable law, any claim or cause of action arising out of or relating to the Software or these Terms must be commenced within one (1) year after the claim arises."
        },
        {
          "t": "p",
          "text": "Claims not commenced within this period are permanently barred."
        }
      ]
    },
    {
      "num": "26",
      "title": "DISPUTE RESOLUTION",
      "blocks": [
        {
          "t": "p",
          "text": "Informal Resolution: Before commencing arbitration or litigation, the claimant must send a written Notice of Dispute to legal@reilm.io containing the claimant's name, account email address, a description of the dispute, the relief requested, and any reasonably relevant supporting information. The parties agree to attempt in good faith to resolve the dispute for at least thirty (30) days before initiating arbitration or litigation."
        },
        {
          "t": "p",
          "text": "Binding Arbitration: Except for claims eligible for small claims court and requests for temporary or preliminary injunctive relief concerning unauthorized access, intellectual property, trade secrets, or confidential information, any dispute arising out of or relating to these Terms or the Software shall be resolved exclusively through individual binding arbitration administered by the American Arbitration Association (\"AAA\")."
        },
        {
          "t": "p",
          "text": "Applicable Rules: If the dispute qualifies as a consumer dispute under applicable AAA standards, the AAA Consumer Arbitration Rules apply. Otherwise, the AAA Commercial Arbitration Rules apply. If these Terms conflict with any mandatory AAA consumer requirements, those requirements control."
        },
        {
          "t": "p",
          "text": "Location and Format: Arbitration may be conducted by written submissions, telephone, videoconference, or in person, as permitted under the applicable AAA rules. Any in-person consumer hearing will take place at a reasonably convenient location as required by applicable law and the AAA rules."
        },
        {
          "t": "p",
          "text": "Fees: Arbitration filing fees and costs will be allocated in accordance with the applicable AAA rules and fee schedules. The Company will pay any fees it is required to pay under applicable consumer arbitration rules."
        },
        {
          "t": "p",
          "text": "Small Claims: Either party may bring an individual claim in a court of competent small claims jurisdiction where permitted by applicable law."
        },
        {
          "t": "p",
          "text": "Class and Representative Action Waiver: To the maximum extent permitted by law, each party may bring claims only in its individual capacity and not as a plaintiff or class member in any class, collective, coordinated, consolidated, mass, or representative proceeding."
        },
        {
          "t": "p",
          "text": "Jury Trial Waiver: For disputes not subject to arbitration, each party knowingly and voluntarily waives the right to a trial by jury to the maximum extent permitted by law."
        },
        {
          "t": "p",
          "text": "Opt-Out: You may opt out of this arbitration agreement by sending written notice to legal@reilm.io within thirty (30) days after first accepting these Terms. The notice must include your full name, account email address, and an unambiguous statement that you are opting out of binding arbitration. Opting out does not affect any other provision of these Terms."
        },
        {
          "t": "p",
          "text": "Unavailability of AAA: If the AAA is unavailable or declines to administer the arbitration and the parties cannot agree on a substitute administrator, either party may ask a court of competent jurisdiction to appoint an arbitrator or substitute administrator consistent with applicable law."
        }
      ]
    },
    {
      "num": "27",
      "title": "EXPORT CONTROL COMPLIANCE",
      "blocks": [
        {
          "t": "p",
          "text": "You agree to comply with all applicable export control, economic sanctions, and trade laws and regulations of the United States and any other applicable jurisdiction."
        },
        {
          "t": "p",
          "text": "You represent and warrant that you are not located in, organized under the laws of, or ordinarily resident in any country or territory subject to comprehensive U.S. trade sanctions, and that you are not identified on any U.S. government list of prohibited or restricted parties."
        }
      ]
    },
    {
      "num": "28",
      "title": "ENTIRE AGREEMENT & AMENDMENTS",
      "blocks": [
        {
          "t": "p",
          "text": "Entire Agreement: These Terms constitute the entire and exclusive agreement between you and the Company concerning the Software and supersede all prior or contemporaneous agreements, communications, representations, and understandings, whether written or oral, including any prior beta, pilot, trial, or confidentiality agreements, unless expressly incorporated by reference."
        },
        {
          "t": "p",
          "text": "Acceptance: Your registration for, access to, purchase of, or use of the Software constitutes your acceptance of these Terms and supersedes any conflicting terms, except as expressly provided herein."
        },
        {
          "t": "p",
          "text": "Order of Precedence: If these Terms conflict with a mutually executed order form, the order form controls solely with respect to the applicable transaction. If the Pricing Page conflicts with these Terms, these Terms control except as to plan-specific pricing, billing periods, usage limits, and entitlements expressly displayed at the time of purchase."
        },
        {
          "t": "p",
          "text": "Amendments: The Company may update these Terms from time to time. Non-material changes become effective upon posting. Material changes become effective on the date specified in the applicable notice. Where required by law, the Company will provide reasonable advance notice through the Software, by email, or by another appropriate method. Your continued use of the Software after the effective date constitutes acceptance of the updated Terms, except where applicable law requires affirmative consent."
        },
        {
          "t": "p",
          "text": "No Modification by User: No modification or amendment proposed by you is binding unless contained in a written agreement signed by an authorized officer of the Company. No employee, contractor, or other representative has authority to modify these Terms otherwise."
        }
      ]
    },
    {
      "num": "29",
      "title": "ASSIGNMENT",
      "blocks": [
        {
          "t": "p",
          "text": "The Company may assign these Terms, in whole or in part, in connection with a merger, acquisition, financing, corporate reorganization, sale of assets, or transfer of the Software or the Company's business."
        },
        {
          "t": "p",
          "text": "You may not assign, transfer, delegate, sublicense, or otherwise convey any rights or obligations under these Terms without the Company's prior written consent. Any attempted assignment in violation of this section is void."
        },
        {
          "t": "p",
          "text": "These Terms bind and benefit the parties and their respective permitted successors and assigns."
        }
      ]
    },
    {
      "num": "30",
      "title": "SEVERABILITY",
      "blocks": [
        {
          "t": "p",
          "text": "If any provision of these Terms is held invalid, illegal, or unenforceable, the remaining provisions remain in full force and effect. Any invalid, illegal, or unenforceable provision will be enforced to the maximum extent permitted by law so as to best accomplish its intended purpose."
        }
      ]
    },
    {
      "num": "31",
      "title": "WAIVER",
      "blocks": [
        {
          "t": "p",
          "text": "No failure or delay by the Company in exercising any right or remedy under these Terms operates as a waiver of that right or remedy. No waiver is effective unless it is in writing and signed by an authorized representative of the Company."
        },
        {
          "t": "p",
          "text": "A waiver of any provision or breach does not constitute a waiver of any other provision, breach, or future breach."
        }
      ]
    },
    {
      "num": "32",
      "title": "NO PARTNERSHIP, AGENCY, OR FIDUCIARY DUTY",
      "blocks": [
        {
          "t": "p",
          "text": "Nothing in these Terms creates any partnership, joint venture, agency, fiduciary, employment, or advisory relationship between you and the Company."
        },
        {
          "t": "p",
          "text": "You acknowledge that the Company does not act as your agent, broker, advisor, fiduciary, or representative. The Software is provided solely as a tool, and all business, investment, and legal decisions remain solely your responsibility."
        }
      ]
    },
    {
      "num": "33",
      "title": "BUSINESS USE ACKNOWLEDGMENT",
      "blocks": [
        {
          "t": "p",
          "text": "You acknowledge that the Software is intended primarily for commercial real estate analysis, investment, and related business activities."
        },
        {
          "t": "p",
          "text": "34. CONTACT INFORMATION Questions regarding these Terms may be directed to:"
        },
        {
          "t": "p",
          "text": "Arvance, LLC 2296 Henderson Mill Rd NE, #116 Atlanta, GA 30345"
        },
        {
          "t": "p",
          "text": "Email: legal@reilm.io"
        },
        {
          "t": "p",
          "text": "Legal notices under these Terms, including arbitration opt-out notices, must be sent to legal@reilm.io."
        },
        {
          "t": "p",
          "text": "The Company may provide notices to you by email, through the Software, or by any other method permitted by applicable law using the contact information associated with your account."
        }
      ]
    }
  ]
};
export default TOS;
